import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import {
  buildRelationsMapForLookBook,
  calculateProductsInPlay,
  RelationsMapForLookBook,
} from 'ZalamoLibrary/src/lib/ui/look-book-front/helpers';
import { calculateProductPriceFromParams } from 'ZalamoLibrary/src/lib/ui/products/products-front/helpers';
import {
  LookBookPriceRounding,
  Product,
} from '../../../../../../photographer-panel/src/graphql';
import {
  GetAvailableWallDecorConfigsGQL,
  Maybe,
  Scalars,
  WallDecorPieceForDisplay,
  WallDecorPieceForDisplayType,
} from 'ZalamoLibrary/src/lib/ui/look-book-front/wall-decor-front/graphql';

const relationsMap: Record<string, RelationsMapForLookBook> = {};

@Injectable({
  providedIn: 'root',
})
export class WallDecorPriceCalculatorService {
  constructor(
    private getAvailableWallDecorConfigs: GetAvailableWallDecorConfigsGQL,
  ) {}

  calculatePrice(
    value: WallDecorPieceForDisplay[],
    config: {
      labsInPlay: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
      zalamoStandaloneWallDecor: Omit<Product, 'hasTaxConfig' | 'taxConfig'>;
      zalamoStandaloneTambour: Omit<Product, 'hasTaxConfig' | 'taxConfig'>;
      labProducts: Omit<Product, 'hasTaxConfig' | 'taxConfig'>[];
    },
    rounding: LookBookPriceRounding,
    preConfig: string,
  ) {
    console.log(`

    PRECONFIG


    `);
    console.log(preConfig);
    const currentSourceProduct =
      value[0].type === WallDecorPieceForDisplayType.Canvas
        ? config.zalamoStandaloneWallDecor
        : config.zalamoStandaloneTambour;
    if (!relationsMap[currentSourceProduct.productId]) {
      relationsMap[currentSourceProduct.productId] =
        buildRelationsMapForLookBook(JSON.parse(currentSourceProduct.config));
    } else {
    }
    config = {
      ...config,
      labsInPlay: config.labProducts
        .filter(({ type }) => String(type) === String(value[0].type))
        .map(({ organizationId }) => organizationId),
    };

    return this.getAvailableWallDecorConfigs.fetch({}).pipe(
      map(({ data: { getAvailableWallDecorConfigs } }) => {
        let price = value.reduce((sum, piece) => {
          const v = getAvailableWallDecorConfigs?.find(
            ({ wallDecorConfigId }) =>
              piece.wallDecorConfigId === wallDecorConfigId,
          )?.config;
          const productsMap: Record<
            string,
            Array<Product & { labId: string }>
          > = config.labProducts.reduce(
            (prev, p) => {
              if (typeof prev[p.organizationId] === 'undefined') {
                prev[p.organizationId] = [];
              }
              prev[p.organizationId].push({
                ...p,
                tags: [],
                labId: p.organizationId,
                __typename: 'Product',
                hasTaxConfig: false,
                taxConfig: null,
              });
              return prev;
            },
            {} as {
              [x: string]: Array<Product & { labId: string }>;
            },
          );
          // console.log(v);
          // @ts-ignore
          const currentValue = Object.fromEntries(
            Object.entries(JSON.parse(v) as Record<string, { value }>).map(
              ([index, { value }]) => [index, value],
            ),
          );
          if (preConfig) {
            Object.entries(
              JSON.parse(preConfig) as Record<string, string>,
            ).forEach(([index, preConfigValue]) => {
              currentValue[index] = preConfigValue;
            });
          }
          const { productsInPlay, mappedValues } = calculateProductsInPlay(
            config.labsInPlay,
            productsMap,
            currentValue,
            JSON.parse(currentSourceProduct.config),
            relationsMap[currentSourceProduct.productId],
            Object.keys(currentValue).length - 1,
          );
          const prices = productsInPlay.map((product) =>
            calculateProductPriceFromParams(
              {
                ...product,
                config:
                  typeof product.config === 'string'
                    ? JSON.parse(product.config)
                    : product.config,
              },
              {
                ...mappedValues[product.productId],
                ...(preConfig ? JSON.parse(preConfig) : {}),
              },
              'PLN',
            ),
          );
          if (prices.length === 1 || prices[0] === prices[1]) {
            return sum + prices[0];
          } else {
            const current = prices.sort();
            return sum + current[0];
          }
          // console.log();
          return null;
        }, 0);
        switch (rounding) {
          case LookBookPriceRounding.One:
            price = Math.ceil(price);
            break;
          case LookBookPriceRounding.Five:
            price = Math.ceil(price / 5) * 5;
            break;
          case LookBookPriceRounding.Ten:
            price = Math.ceil(price / 10) * 10;
            break;
        }
        return price;
      }),
    );
  }
}
